import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Util } from "reactstrap";
import styles from "./CodiceUnivoco.module.css";

const { mapToCssModules, deprecated, warnOnce } = Util;

const propTypes = {
    children: PropTypes.node,
    type: PropTypes.string,
    size: PropTypes.string,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    autoComplete: PropTypes.string,
    value: PropTypes.string,
    id: PropTypes.string,
    infoText: PropTypes.string,
    normalized: PropTypes.bool,
    bsSize: PropTypes.string,
    state: deprecated(
        PropTypes.string,
        'Please use the props "valid" and "invalid" to indicate the state.'
    ),
    valid: PropTypes.bool,
    invalid: PropTypes.bool,
    tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
    onChange: PropTypes.func,
    onValidate: PropTypes.number,
    innerRef: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.func,
        PropTypes.string,
    ]),
    static: deprecated(PropTypes.bool, 'Please use the prop "plaintext"'),
    plaintext: PropTypes.bool,
    addon: PropTypes.bool,
    className: PropTypes.any,
    styleErrorMessage: PropTypes.string,
    spanStyle: PropTypes.object,
    cssModule: PropTypes.object,
    errorMessage: PropTypes.string,
};

const defaultProps = {
    type: "text",
    autoComplete: "off",
};

class CodiceUnivoco extends React.Component {
    state = {
        isFocused: false,
        hidden: true,
        icon: true,
        className: this.props.className,
        timeout: null,
        hasChanged: false,
    };

    constructor(props) {
        super(props);

        this.toggleShow = this.toggleShow.bind(this);
    }

    componentDidMount() {
        if (
            this.props.value !== null ||
            this.props.value !== undefined ||
            this.props.value !== ""
        ) {
            this.setState({ value: this.props.value });
        }

        if (this.props.type == "number") {
            let invalidChars = ["-", "+", "e", "=", "_"];
            document
                .getElementById(this.props.id)
                .addEventListener("keydown", function (e) {
                    if (invalidChars.includes(e.key)) {
                        e.preventDefault();
                    }
                });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.value !== this.props.value) {
            if (this.props.onValidate) {
                let ret = this.props.onValidate;
                if (ret) {
                    if (ret == 1) {
                        this.setState({
                            className: this.addErrorClass(),
                            errorMessage: this.props.errorMessage,
                            styleErrorMessage: "inline",
                        });
                    } else if (ret == 2) {
                        this.setState({
                            className: this.removeErrorClass(),
                            errorMessage: "",
                            styleErrorMessage: "none",
                        });
                    }
                }
            }
        }
    }

    invokeValidate = (val) => {
        if (this.props.onValidate) {
            let ret = this.props.onValidate;
            if (ret) {
                if (ret == 1) {
                    this.setState({
                        className: this.addErrorClass(),
                        errorMessage: this.props.errorMessage,
                        styleErrorMessage: "inline",
                    });
                } else if (ret == 2) {
                    this.setState({
                        className: this.removeErrorClass(),
                        errorMessage: "",
                        styleErrorMessage: "none",
                    });
                } else {
                    this.setState({
                        className: this.removeErrorClass(),
                        errorMessage: "",
                        styleErrorMessage: "none",
                    });
                }
            } else {
                this.setState({
                    className: this.removeErrorClass(),
                    errorMessage: "",
                    styleErrorMessage: "none",
                });
            }
        } else {
            this.setState({
                className: this.removeErrorClass(),
                errorMessage: "",
                styleErrorMessage: "none",
            });
        }

        if (this.props.onChange) {
            this.props.onChange(this.props.field, {
                target: { value: val },
            });
        }
    };

    handleOnChange = (e) => {
        let that = this;
        let val = e.target.value;

        this.setState({ value: val });

        if (this.props.onChange) {
            this.props.onChange(this.props.field, {
                target: { value: val },
            });
        }

        if (this.state.timeout) {
            clearTimeout(this.state.timeout);
        }
        this.state.timeout = setTimeout(() => that.invokeValidate(val), 300);
    };

    removeErrorClass = () => {
        if (typeof this.state.className === "string") {
            this.state.className = "txtInput";
        } else if (Array.isArray(this.state.className)) {
            if (this.state.className.regexIndexOf("errorBorder") != -1)
                this.state.className.splice(
                    this.state.className.regexIndexOf("errorBorder"),
                    1
                );
            if (this.state.className.regexIndexOf("txtInput") == -1)
                this.state.className.push("txtInput");
        }
        return this.state.className;
    };

    addErrorClass = () => {
        if (typeof this.state.className === "string") {
            this.state.className = styles.errorBorder;
        } else if (Array.isArray(this.state.className)) {
            if (this.state.className.regexIndexOf("txtInput") != -1)
                this.state.className.splice(
                    this.state.className.regexIndexOf("txtInput"),
                    1
                );
            if (this.state.className.regexIndexOf("errorBorder") == -1)
                this.state.className.push(styles.errorBorder);
        }
        return this.state.className;
    };

    toggleFocusLabel = () => {
        this.setState({
            isFocused: true,
        });
    };

    toggleBlurLabel = (e) => {
        if (this.props.onBlur !== undefined) this.props.onBlur();

        if (e.target.value === "") {
            this.setState({
                isFocused: !this.state.isFocused,
            });
        }
    };

    toggleShow() {
        this.setState({ hidden: !this.state.hidden, icon: !this.state.icon });
    }

    render() {
        const {
            cssModule,
            parentClass,
            type,
            state,
            tag,
            addon,
            static: staticInput,
            plaintext,
            innerRef,
            label,
            infoText,
            infoTextControlClass,
            placeholder,
            normalized,
            value,
            onValidate,
            spanStyle,
            ...attributes
        } = this.props;
        let { bsSize, valid, invalid } = this.props;

        if (!this.state.className) {
            this.state.className = "";
        }
        if (this.state.className.regexIndexOf("errorBorder") == -1) {
            this.removeErrorClass();
        }

        let Tag = "input";

        let formControlClass = "form-control";

        if (plaintext || staticInput) {
            formControlClass = `${formControlClass}-plaintext`;
            Tag = tag || "p";
        }

        if (
            state &&
            typeof valid === "undefined" &&
            typeof invalid === "undefined"
        ) {
            if (state === "danger") {
                invalid = true;
            } else if (state === "success") {
                valid = true;
            }
        }

        let classes = mapToCssModules(
            classNames(
                this.state.className,
                invalid && "is-invalid",
                valid && "is-valid",
                bsSize ? `form-control-${bsSize}` : false,
                formControlClass,
                this.props.required ? styles.placeholder : ""
            ),
            cssModule
        );

        let wrapperClass = mapToCssModules(classNames(parentClass), cssModule);

        if (Tag === "input" || typeof tag !== "string") {
            attributes.type = type;
        }

        let spanErrorMessage = (
            <span
                style={{ display: this.state.styleErrorMessage }}
                className="invalid-feedback"
            >
                {this.state.errorMessage}
            </span>
        );

        let divSpan = <div style={spanStyle}>{spanErrorMessage}</div>;

        classes = this.props.noOpacityOnDisabled
            ? [classes, "noOpacityOnDisabled"].join(" ").replace("txtInput", "")
            : classes;
        classes = [classes, "elemento-visualizzazione"].join(" ");
        return (
            <div className={wrapperClass}>
                <Tag
                    {...attributes}
                    autoComplete={this.props.autoComplete}
                    ref={innerRef}
                    className={classes}
                    id={this.props.id}
                    onChange={(e) => this.handleOnChange(e)}
                    onFocus={
                        this.props.onFocus
                            ? this.props.onFocus
                            : this.toggleFocusLabel
                    }
                    onBlur={(e) => this.toggleBlurLabel(e)}
                    placeholder={
                        this.props.required
                            ? this.props.placeholder + "*"
                            : this.props.placeholder
                    }
                    value={this.props.value}
                    style={{
                        textTransform: this.props.value
                            ? "uppercase"
                            : undefined,
                    }}
                />
                {divSpan}
            </div>
        );
    }
}

CodiceUnivoco.propTypes = propTypes;
CodiceUnivoco.defaultProps = defaultProps;

export default CodiceUnivoco;
